var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcGround(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2751 5.40039H4.72688C4.50823 5.40039 4.30689 5.51933 4.20137 5.71083L1.22778 11.1073C1.08088 11.3739 1.27374 11.7004 1.57811 11.7004H16.4239C16.7283 11.7004 16.9211 11.3739 16.7742 11.1073L13.8006 5.71083C13.6951 5.51933 13.4938 5.40039 13.2751 5.40039Z",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGround);
export default __webpack_public_path__ + "static/media/ic_ground.d0f391aac6d0fafa6fe5bd3913140bef.svg";
export { ForwardRef as ReactComponent };